if ($('.ordering-process').length) {

  function newFooter() {
    if ($('.id--9').length) {
      if ($('.cart-empty').length) {
        emptyCart();
      }
      document.addEventListener('ShoptetDOMContentLoaded', function () {
        if ($('.cart-empty').length) {

          emptyCart();
        }
      });
    }

  }
  $(document).ready(function () {
    loadFooter(newFooter);
  });

}


function emptyCart() {
  $('body').addClass('cartemptycustom');
  $("h1:not(.sr-only), .h1:not(.sr-only)").after($("#footer .emptyCartText"));
}


if ($(".id--17").length) {

  //$('#consentsheurekaConsent').prop('checked', true);
  // $('#consentszboziConsent').trigger('click');
  // $('#consentszboziConsent').prop('checked', true);
  //$('#consentszboziConsent').attr('data-gtm-form-interact-field-id', '1')

  $(".order-button-suffix").text("a zaplatit");

  var $checkoutInputs = $(
    '.id--17 textarea,.id--17 input[type="text"], .id--17 input[type="email"], .id--17 input[type="password"], .id--17 input[type="tel"]',
  );
  $checkoutInputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
    //console.log($(this));
    // console.log($(this).val());
  });

  $checkoutInputs.on("click focus", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  if ($('#billFullName').val()) {
    $('#billFullName').closest('.form-group').toggleClass('focused', true);
  }

  $checkoutInputs.on("blur", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $('.co-contact-information').prepend(`
            <div class="customLogin">
                    <p>Máte u nás účet? Přihlaste se, údaje se vyplní automaticky. 
                <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);


  }
}


$('html').on('click', '.customLoginPopup', function () {
  $('body').addClass('user-action-visible login-window-visible');

})


if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));

  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());

  $.get(
    "/action/Cart/GetCartContent/?orderingProcessActive=1",
    function (data) {
      $('.cart-item[data-micro="cartItem"]').each(function () {
        get_id = $(this).attr("data-micro-sku");
        var $row = $(this);
        link = $(data.payload.content)
          .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image a')
          .attr("href");
        image = $(data.payload.content)
          .find(
            '.removeable[data-micro-sku="' + get_id + '"] .cart-p-image img',
          )
          .attr("data-src")
          .replace("related", "detail");
        if (!$(this).find(".right").length) {
          $(this).wrapInner('<div class="right"></div>');
          $(this).prepend(
            '<div class="image"><a href="' +
            link +
            '"><img src="' +
            image +
            '" alt="' +
            $(this).find('a[data-testid="recapItemName"]').text() +
            '"></a></div>',
          );
        }
      });
    },
  );
}

if ($(".id--15").length) {
  $("h1").text("Objednávka přijata");
  $("h1").after("<p>Děkujeme za Vaši objednávku</p>");
  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith("Její číslo: ");

/*  $('.recapitulation-wrapper[data-testid="recapTable"]').append(
    '<div class="co-box co-extra"></div>',
  );
  $(".co-box.co-extra").append(
    $('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])'),
  );*/
  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);
    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");
      $row.append(
        '<td class="zdarma"><span>Zdarma</span></td>',
      );
      $row.find("strong.for-free").text("Dárek k objednávce");
      //  console.log("true");
    }
    const $cell = $row.find("td.p-quantity");
    if (!$cell.length) return;

    const total = parseFloat(
      $cell
        .find("strong")
        .text()
        .replace(/\s/g, "")
        .replace("Kč", "")
        .replace(",", "."),
    );
    $row.append(`<td class="pricePerSingle"><span>${total} / ks</span></td>`);
  });
}

if ($(".id--16").length) {
  $("#orderFormButton span").text("Pokračovat na objednávku");
  $(document).on("click", "#checkoutSidebar h4", function () {
    $(this).closest(".order-summary-inner").toggleClass("open");
  });
}

function mhProductInfoMove() {
  if ($(".id--9").length) {
    if ($(".extra.delivery span .price-range").length) {
      $(".extra.delivery").append(
        $(".extra.delivery span .price-range").clone(),
      );
    }
    let maxDeliveryDate = null;

    $("tr.removeable").each(function () {

      $(this).find(".p-name").append($(this).find(".p-availability").clone());
      $(this).find(".p-total").append($(this).find(".p-price").clone());

      if ($(this).find('.p-name a.show-related').length) {
        $(this).find('.p-name .show-related').text('Nepotřebujete ještě něco?');
      }

      $(this).find('.availability-amount').each(function () {

        const $amount = $(this);
        const availabilityText = $amount.text().replace('(', '').replace(')', '').replace('>', '> ');
        $amount.text(availabilityText + ',');

        $amount.attr('style', $(this).prev('.availability-label').attr('style'));

        const availabilityCartText = $(this).prev('.availability-label').text().trim().toLowerCase();

        const deliveryCartDate = getDeliveryDateByAvailability(availabilityCartText);

        if (!deliveryCartDate) return;

        // 👉 uložíme nejvyšší datum
        if (!maxDeliveryDate || deliveryCartDate > maxDeliveryDate) {
          maxDeliveryDate = deliveryCartDate;
        }

        const formattedCartDate = formatDeliveryDate(deliveryCartDate);

        $(this).after(
          `<div class="deliveryDate" style="${$(this).prev('.availability-label').attr('style')}">${formattedCartDate}</div>`
        );

      });

    });


    // 👉 po dokončení loopu uložíme datum
    if (maxDeliveryDate) {

      const formattedMaxDate =
        maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";

      localStorage.setItem('maxDeliveryDate', formattedMaxDate);

      //console.log('Max delivery date:', formattedMaxDate);
    }

    if ($(".free-gift").length) {
      $(".free-product-gifts li").each(function () {
        $(this)
          .find(".free-gift-label")
          .prepend(
            `<span class="extraText">Dárek k objednávce</span>`,
          );
        $(this)
          .find(".free-gift-label")
          .append(`<span class="zdarma">Zdarma</span>`);
      });
    }

    if ($(".related").length) {
      $(".related .cart-related-product").each(function () {
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-availability"));
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-name"));
        if ($(this).find('button[type="submit"]').length) {
          $(this).find('button[type="submit"]').text('Koupit');
        }
      });
    }

    $(".summary-wrapper").after($(".next-step-back"));

    $(".summary-wrapper").prepend('<div class="customBox"></div>');

    $(".customBox").append(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                Mám slevový kód
            </label>
        `);
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $('.cart-table').prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="sale">Sleva</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $('tr.removeable').each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find('.p-price .show-tooltip').attr('title') || $row.find('.p-price .show-tooltip').attr('data-original-title');
          //  console.log()
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(',', '.'))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, '')) : 0;
          const finalPrice = parseInt(
            $row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, '')
          );
          const quantity = parseInt($row.find('input.amount').val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find('.p-price').append(`
                    <span class="sale-percent">${percent}%</span>
                `)
          $row.find('.p-total').before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      }
      else {
        $row.find('.p-total').before('<td class="p-sale"></td>');
      }




    });

    if (totalSaved > 0) {
      $('.price-wrapper').append(`
            <span class="price-label price-secondary" style="color:#118819;">
            Ušetřili jste:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }


  } else {
    $('.cart-table').prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
  }



  $(".summary-wrapper .customBox").append(
    $(".cart-summary .discount-coupon").clone(),
  );


  $("#discount-checkbox").on("change", function () {
    $(".discount-coupon").toggleClass("active", this.checked);
  });

  if ($(".delivery-time").length) {
    $(".customBox").append($(".delivery-time"));
  }
  if ($('.discount-coupon .applied-coupon').length) {
    $('.discount-coupon').addClass('active')
    $('#discount-checkbox').prop('checked', true);
    $('input[data-testid="buttonRemoveDiscountCoupon"]').attr('value', 'Odebrat kupon')
  }
}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  mhProductInfoMove();
});





